'use client';

import { CheckableElementProps } from '@/interfaces/basicForm';
import { checkedValue } from '@/utils/helper';
import { useEffect, useState } from 'react';

export const ColorCheckbox = ({ name, colorName, value, label, className = '', selectedValues, onChange }: CheckableElementProps) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(checkedValue(selectedValues, value));
  }, [selectedValues, value]);

  return (
    <label
      className={`checkbox color-checkbox cursor-pointer flex-col border 
           border-transparent
         ${className}`}
    >
      <input
        type="checkbox"
        className="hidden"
        checked={checked}
        {...{ name, value }}
        onChange={(e) => {
          if (checked) {
            setChecked(false);
          } else {
            setChecked(true);
          }
          onChange?.();
        }}
      />
      <div className="group inline-flex items-center">
        <div
          className={`mx-auto flex h-8 w-8 items-center justify-center rounded-[4px] border duration-300 group-hover:scale-110  ${
            checked ? 'checked border-black' : 'border-transparent'
          }`}
        >
          <div
            className="h-6 w-6 rounded-[4px]"
            style={{
              backgroundColor: label?.toLowerCase().includes('#ffffff') && !checked ? '#f0f0f0' : label,
              border: 'solid 1px #ddd',
            }}
          ></div>
        </div>
        <div className="ml-2">{colorName}</div>
      </div>
    </label>
  );
};
